import './steps.scss';

const Steps = ({ step }) => {
  return <div className={`steps row justify-content-center mb-2`}>
    <ul>
      <li className={step >= 1 ? `current`: ``}>
        <div><span>1</span></div>
      </li>
      <li className={step >= 2 ? `current`: ``}>
        <div><span>2</span></div>
      </li>
    </ul>
  </div>
};

export default Steps;
